import React, { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { DiscountType } from '@trnsact/trnsact-shared-types';
import { chargeTypeOptions } from 'modules/quote/constants/form';
import { ListingForm } from 'components/shared/TableListing/types';
import { FieldPath, useFormContext, useWatch } from 'react-hook-form';
import { CurrencyInputField, InterestInputField, RadioGroupField } from 'components/form';

import { BasePrice, Charge } from '../../../types';

interface Props {
  index: number;
  type: keyof BasePrice;
}

export const ChargeValueWithTypesCell = ({ index, type }: Props) => {
  const inputName = `bodyFields.${index}.price.${type}` as FieldPath<ListingForm<Charge>>;
  const inputTypeName = `bodyFields.${index}.price.${type}Type` as FieldPath<ListingForm<Charge>>;

  const { control } = useFormContext<ListingForm<Charge>>();

  const fieldType = useWatch({ control, name: inputTypeName });

  const fieldMapper: Record<DiscountType, ReactNode> = {
    [DiscountType.Percent]: (
      <InterestInputField control={control} name={inputName} textFieldProps={{ variant: 'outlined' }} />
    ),
    [DiscountType.Flat]: (
      <CurrencyInputField allowNegative name={inputName} control={control} textFieldProps={{ variant: 'outlined' }} />
    ),
  };

  const Field = fieldMapper[fieldType as any as DiscountType];

  return (
    <Stack width="100%">
      {Field}

      <RadioGroupField row control={control} name={inputTypeName} options={chargeTypeOptions} />
    </Stack>
  );
};
